import { AlarmBellIcon } from '@libs/ui/ds/assets/icons'
import { IconWrap } from '@libs/ui/ds/lib/components/dataDisplay/IconWrap/base/IconWrap'
import { Indicator } from '@libs/ui/ds/lib/components/dataDisplay/Indicator/base/Indicator'
import type { BaseComponent } from '@libs/ui/ds/lib/internals'
import type { FC, HTMLAttributes, RefObject } from 'react'

import { TopNavbarItem } from '../TopNavbarItem/TopNavbarItem'

type Props = BaseComponent &
  HTMLAttributes<HTMLButtonElement> & {
    count?: number
    ref?: RefObject<HTMLButtonElement>
  }

export const TopNavbarNotification: FC<Props> = ({
  className,
  count,
  onClick,
  ref,
  ...other
}) => {
  return (
    <Indicator
      color='semantic.red'
      size='xs'
      position='top-end'
      label={String(count)}
      hide={!count}
    >
      <TopNavbarItem
        ref={ref}
        className={className}
        onClick={onClick as () => void}
        role='button'
        tabIndex={0}
        {...other}
      >
        <IconWrap size='m' icon={<AlarmBellIcon />} />
      </TopNavbarItem>
    </Indicator>
  )
}
